const i18n = {
	it: {
		download: "Download Docs",
		obiettiviProgettoFirst: "Obiettivi",
        obiettiviProgettoSecond: "di progetto",
		project: "Progetto",
        allProjects: "Tutti i progetti",
        discover: "Scopri di più",
		goToDetail: "Vai al dettaglio",
		allCountrySheets: "Tutte le schede dei paesi",
		scrollHero: "Scorri",
		viewAll: "Vedi tutti",
		readMore: "Approfondisci",
		searchLabs: "Cerca laboratori",
		labCategory: "Tipologia",
		address: "Indirizzo",
		locationLabel: "Dove siamo",
		webSite: "Sito web",
		director: "Direttore",
		directorEmail: "Email del Direttore",
		partner: "Partner",
		scientificManager: "Responsabile Scientifico del Laboratorio",
		scientificManagerShort: "Resp. Scientifico",
		scientificManagerEmail: "Email del Responsabile Scientifico del Laboratorio",
		on: "su",
		open: "Apri",
		sendEmail: "Email",
		sendFormData: "Invia",
		contactLab: "Contatta un laboratorio",
		keepUpdated: "Resta aggiornato",
		elements: "elementi",
		prevPage: "prec",
		nextPage: "succ",
		footerRights: "Tutti i diritti riservati",
		labs: "Laboratori",
		structureLabel: "Strutture",
		energeticTransition: "Transizione energetica",
		digitalTransition: "Transizione digitale",
		bioPharma: "Salute & Bio-Pharma",
		readAll: "Leggi tutto",
		readLess: "Leggi meno",
		searchTitle: "Cerca",
		searchLabel: "Cerca per parola, laboratorio o strumento",
		searchLabelInside: "Effettua una nuova ricerca",
		resultsForSearch: "risultati per la ricerca",
		noResultsForSearch: "Non ci sono risultati per questa chiave di ricerca",
		nothingToSearch: "Niente da cercare qui",
		NotFound: "Pagina non trovata",
		GenericError: "Si è verificato un errore imprevisto",
		backToHp: "Torna alla homepage",
		contactUs: "Contattaci",
		tariffario: "Tariffario",
		regolamento: "Regolamento",
		istitute: "Nodo",
		collabWithUs: "Collabora con noi e costruisci il futuro dell'innovazione",
		collabWithUsText1: "Unisciti al nostro laboratorio e",
		collabWithUsText2: "diventa parte di un ecosistema",
		collabWithUsText3: "che trasforma la ricerca in soluzioni concrete.",
		instrumentsLabel: "Strumenti",
		sector: "Settori",
		sedeEnte: "Partner",
		category: "Sezione",
		filterBy: "Filtra per:",
		filterByLab: "Filtra le strutture:",
		filterBySede: "Con filtro per Sede/Ente:",
		filterBySettore: "Con filtro per Settore:",
		filterByInstrument: "Includendo solo gli strumenti",
		allInstruments: "Tutti i risultati",
		onlyInstruments: "Solo strumenti",
		schoolListLabel: "Scopri tutti i",
		searchHpTitle: "Trova, sperimenta, crea.",
		searchHpTitleNL: "Il laboratorio o la tecnologia che cerchi sono qui.",
		searchHpSubtitle: "Cerca il laboratorio o la tecnologia per il tuo prossimo esperimento.",
		searchHpSubtitleNL: "Usa il motore di ricerca e affina i risultati con i filtri.",
		searchHpSubtitleEnhanced: "",
		searchHpCta: "Il tuo prossimo passo?",
		searchHpCtaBold: "Cercalo qui",
		noLabs: "Non ci sono laboratori per questa chiave di ricerca. Prova a cambiare i filtri.",
		instrumentWhereFind: "Dove trovare questo strumento",
		goBack: "Torna indietro",
		clearFilters: "Cancella filtri",
		struttura: "Nodo",
		dateLabel: "Data",
		foundationName: "Fondazione Pielle24",
		charitableEntity: "Ente filantropico E.T.S.",
		followSocial: "Seguici sui social",
		newsletterSignup: "Iscriviti alla nostra newsletter",
		emailPlaceholder: "Indirizzo e-mail",
		privacyPolicy: "Privacy policy",
		cookiesPolicy: "Cookies policy",
		copyright: "Copyright © 2026 Fondazione Pielle 24",
		vat: "C.F. 95154070247",
		presidente: "Presidente Fondazione Pielle24",
		informativa: "Informativa Privacy",
	},
	en: {
        presidente: "President, Fondazione Pielle24",
        download: "Download Docs",
		obiettiviProgettoFirst: "Project",
        obiettiviProgettoSecond: "objectives",
		project: "Project",
        allProjects: "All projects",
		discover: "Learn more",
		goToDetail: "Go to detail",
		allCountrySheets: "All country sheets",
		scrollHero: "Scroll",
		viewAll: "View all",
		readMore: "Explore",
		searchLabs: "Search labs",
		labCategory: "Type",
		address: "Address",
		locationLabel: "Where we are",
		webSite: "Website",
		partner: "Partner",
		director: "Director",
		directorEmail: "Director email",
		scientificManager: "Scientific Manager",
		scientificManagerEmail: "Scientific Manager email",
		on: "on",
		open: "Open",
		contactLab: "Contact a lab",
		sendEmail: "Email",
		sendFormData: "Send",
		keepUpdated: "Keep updated",
		elements: "elements",
		prevPage: "prev",
		nextPage: "next",
		footerRights: "All rights reserved",
		labs: "Labs",
		structureLabel: "Structures",
		energeticTransition: "Energetic transition",
		digitalTransition: "Digital transition",
		bioPharma: "Healt & Bio-Pharma",
		readAll: "Read more",
		readLess: "Read less",
		schoolListLabel: "Discover all",
		searchTitle: "Search",
		searchLabel: "Search by word, laboratory or tool",
		searchLabelInside: "Make a new search",
		resultsForSearch: "results for search",
		noResultsForSearch: "No results for this search key",
		nothingToSearch: "Nothign to search here",
		NotFound: "Page not found",
		GenericError: "Something went wrong",
		backToHp: "Back to homepage",
		contactUs: "Contact us",
		tariffario: "Price list",
		regolamento: "Regulation",
		istitute: "Node",
		collabWithUs: "Collaborate with us and build the future of innovation",
		collabWithUsText1: "Join our lab and",
		collabWithUsText2: "become part of an ecosystem",
		collabWithUsText3: "that transforms research into concrete solutions.",
		instrumentsLabel: "Instruments",
		sector: "Sectors",
		sedeEnte: "Partner",
		category: "Section",
		filterBy: "Filter by:",
		filterByLab: "Filter structures:",
		filterBySede: "Filtered by Site/Entity:",
		filterBySettore: "Filtered by Sector:",
		filterByInstrument: "Including only the instruments",
		allInstruments: "All results",
		onlyInstruments: "Only instruments",
		searchHpTitle: "Find, experience, create.",
		searchHpTitleNL: "The lab or technology you are looking for is here.",
		searchHpSubtitle: "Find the lab or technology for your next experiment.",
		searchHpSubtitleNL: "Use the search engine and refine your results with the filters.",
		searchHpSubtitleEnhanced: "",
		searchHpCta: "Your next step?",
		searchHpCtaBold: "Search it here",
		loLabs: "Not labs for this search key. Try to change the filters.",
		instrumentWhereFind: "Where to find this instrument",
		goBack: "Go Back",
		"clearFilters": "Clear filters", 
		struttura: "Node",
		dateLabel: "Date",
		foundationName: "Fondazione Pielle24",
		charitableEntity: "Charitable entity E.T.S.",
		followSocial: "Follow us on social",
		newsletterSignup: "Subscribe to our newsletter",
		emailPlaceholder: "Email address",
		privacyPolicy: "Privacy policy",
		cookiesPolicy: "Cookies policy",
		copyright: "Copyright © 2026 Fondazione Pielle 24",
		vat: "C.F. 03173458372828",
		informativa: "Privacy Statement"
	}
};

export default i18n;
